/* Copyright (c) Trimble Inc. All rights reserved. */

import { useEffect } from "react";
import { ProductListViewModel } from "./ProductList.viewer";
import { AsyncActionState, useAsyncAction } from "legacy-components/form/action/AsyncAction";
import {  from, of } from "rxjs";
import { Product } from "./ProductStackview";
import { Controller } from "modus/utilities/ViewController";
import { IProduct } from "pages/home/consumer/service/ProductService";
import { AxiosResponse } from "axios";
import { ConsumerProductService } from "pages/home/consumer/service/ConsumerProductService";

/**
 * @name useTeamListController
 * @description controller to handle TeamList component functionalities and serves model for ApplicationViewer
 * @type Controller
 * @input TeamListControllerProps
 * @output TeamListViewModel
 */
export const useProductListController:Controller<{},ProductListViewModel> = () => {
    const [response, {subscribe}] = useAsyncAction(() => ConsumerProductService.getProductList());
    // Input details
    useEffect(() => {
        subscribe();
    }, [subscribe]);
    console.log(response);

    return {
        asyncResponse : response as AsyncActionState<AxiosResponse<IProduct[]> | null>
        ,
    };
};
